/*    
<summary>
  This functional component "AddCategoryManagementForm" provides form to add new user or update existing user.
  Developer:Sahil Bharti, Created Date:06-January-2025
</summary>
<returns>Returns JSX</returns>
*/

import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import LoaderButton from "../../../../shared-components/button/loader-button";
import FormikFormInput from "../../../../shared-components/FormikFormHandlers/FormikFormInput";
import FormLoader from "../../../../shared-components/FormLoader/FormLoader";
import Label from "../../../../shared-components/label/label";
import { AddCategoryValidationSchema } from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema";

interface IProps {
  id: number;
  isLoading: boolean;
  editMode: boolean;
  distinction: number;
  businessType: number;
  selectedDetails: any;
  selectedPath: string;
  orderLength: number;
  submitHandler: (data: any) => void;
  onModalClosed: () => void;
  initialValues: any;
}

const AddCategoryManagementForm = (props: IProps) => {
  return (
    <>
      <Modal show={true} centered size="sm">
        <Modal.Header>
          <Modal.Title>
            {<FormattedMessage id="category_details" />}
            <button
              onClick={props.onModalClosed}
              disabled={props.isLoading}
              className="Crossicons"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={props.initialValues}
          enableReinitialize
          validateOnBlur={false}
          validationSchema={AddCategoryValidationSchema}
          onSubmit={async (values) => {
            let addObj = {
              CategoryName: values.Category,
              BusinessTypeId: props.businessType,
              Distinction: props.distinction,
              OrderId: props.orderLength,
              ParentCategoryId: props.id,
              Description: values.Description,
              Details: JSON.stringify(props.selectedDetails),
            };
            let updateObj = {
              Id: props.id,
              CategoryName: values.Category,
              BusinessTypeId: props.businessType,
              Distinction: props.distinction,
              OrderId: props.initialValues?.OrderpId,
              ParentCategoryId: props.initialValues?.ParentCategoryId,
              Description: values.Description,
              Details: props.initialValues?.Details,
              IsNameChanged: props.initialValues.Category !== values.Category,
            };
            props.submitHandler(props.editMode == true ? updateObj : addObj);
          }}
        >
          {({ setFieldValue, values }) => (
            <Form className="user-form">
              {props.isLoading && <FormLoader loading={props.isLoading} />}
              <Modal.Body>
                <div className="form-group mb-3 row">
                  {props.id !== 0 && (
                    <div className="col-sm-12">
                      <Label
                        className="label-style"
                        required={false}
                        label="selected_path"
                      />
                      <Field
                        className="form-control"
                        name="Path"
                        type="text"
                        disabled
                        value={props.selectedPath}
                        placeholder="enter_category_name"
                        as={FormikFormInput}
                        // validcharacter={[
                        //   "・",
                        //   "／",
                        //   "－",
                        //   "～",
                        //   "＋",
                        //   "（",
                        //   "）",
                        //   "［",
                        //   "］",
                        //   "※",
                        //   "：",
                        //   "★",
                        //   "☆",
                        //   "◎",
                        //   "○",
                        //   "●",
                        //   "◆",
                        //   "◇",
                        //   "■",
                        //   "□",
                        //   "→",
                        //   "⇒",
                        //   "♪",
                        //   "(",
                        //   ")",
                        //   "【",
                        //   "】",
                        //   "￥",
                        //   '"',
                        //   "＜",
                        //   "＞",
                        //   "！",
                        //   "？",
                        //   "↓",
                        //   "↑",
                        //   "←",
                        //   "．",
                        //   '"',
                        //   "゛",
                        //   "'",
                        //   "'",
                        //   '"',
                        //   '"',
                        //   "、",
                        //   "。",
                        //   "《",
                        //   "》",
                        //   "~",
                        //   "`",
                        //   "@",
                        //   "#",
                        //   "$",
                        //   "%",
                        //   "^",
                        //   "&",
                        //   "_",
                        //   "=",
                        //   "{",
                        //   "}",
                        //   "|",
                        //   "\\",
                        //   ";",
                        //   "<",
                        //   ",",
                        //   ">",
                        //   ".",
                        //   "?",
                        //   "/",
                        // ]}
                      />
                    </div>
                  )}
                  {/* {JSON.stringify(props.initialValues)} */}
                  <div className="col-sm-12 mt-2">
                    <Label
                      className="label-style"
                      required={true}
                      label="category"
                    />
                    <Field
                      className="form-control"
                      name="Category"
                      type="text"
                      placeholder="enter_category_name"
                      // validcharacter={[" ", ".", ",", "(", ")", "[", "]", "&"]}
                      validcharacter={[
                        "・",
                        "／",
                        "－",
                        "～",
                        "＋",
                        "（",
                        "）",
                        "［",
                        "］",
                        "※",
                        "：",
                        "★",
                        "☆",
                        "◎",
                        "○",
                        "●",
                        "◆",
                        "◇",
                        "■",
                        "□",
                        "→",
                        "⇒",
                        "♪",
                        "(",
                        ")",
                        "【",
                        "】",
                        "￥",
                        '"',
                        "＜",
                        "＞",
                        "！",
                        "？",
                        "↓",
                        "↑",
                        "←",
                        "．",
                        '"',
                        "゛",
                        "'",
                        "'",
                        '"',
                        '"',
                        "、",
                        "。",
                        "《",
                        "》",
                        "+",
                        "-",
                        "[",
                        "]",
                        "|",
                        "*",
                        "&",
                        "/",
                      ]}
                      as={FormikFormInput}
                    />
                  </div>
                  <div className="col-sm-12 mt-2">
                    <Label
                      className="label-style"
                      required={false}
                      label="description"
                    />
                    <Field
                      className="form-control"
                      name="Description"
                      type="text"
                      placeholder="description"
                      validcharacter={[
                        "・",
                        "／",
                        "－",
                        "～",
                        "＋",
                        "（",
                        "）",
                        "［",
                        "］",
                        "※",
                        "：",
                        "★",
                        "☆",
                        "◎",
                        "○",
                        "●",
                        "◆",
                        "◇",
                        "■",
                        "□",
                        "→",
                        "⇒",
                        "♪",
                        "(",
                        ")",
                        "【",
                        "】",
                        "￥",
                        '"',
                        "＜",
                        "＞",
                        "！",
                        "？",
                        "↓",
                        "↑",
                        "←",
                        "．",
                        '"',
                        "゛",
                        "'",
                        "'",
                        '"',
                        '"',
                        "、",
                        "。",
                        "《",
                        "》",
                        "+",
                        "-",
                        "[",
                        "]",
                        "|",
                        "*",
                        "&",
                        "/",
                        ".",
                        "!",
                        "@",
                        "#",
                        "$",
                        "%",
                        "^",
                        "_",
                        "`",
                        "{",
                        "}",
                        "?",
                        ";",
                        ":",
                        ",",
                        "=",
                        "~",
                        "<",
                        ">",
                      ]}
                      as={FormikFormInput}
                    />
                    <p className="small text-muted text-end mt-1">{`${
                      values.Description ? values.Description.length : 0
                    }/40`}</p>
                  </div>
                </div>
              </Modal.Body>
              {/* Footer Buttons */}
              <div className="modal-footer center-content">
                <Button
                  variant="outline-danger"
                  type="button"
                  onClick={props.onModalClosed}
                  disabled={props.isLoading}
                >
                  <i className="bi bi-x-lg me-1"></i>
                  <FormattedMessage id="close" />
                </Button>
                <LoaderButton
                  type="submit"
                  iconName="bi-check-lg"
                  isLoading={props.isLoading}
                  text={props.editMode ? "button_update" : "add"}
                />
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default AddCategoryManagementForm;
